import { building } from "core/UrlEndpoints";
import CrudService from "./CrudService";
import { fetchDataJson } from "../FetchApi";


class BuildingService extends CrudService {
  constructor() {
    super(building);
  }

  async getBuildingWithDetails(id) {
    return fetchDataJson(`${building}/GetWithDetails/${id}`, {
      method: "GET",
    });
  }

}

export default new BuildingService();
